import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './assets/js/flexible';
import 'vant/lib/index.css';
import axios from 'axios'//引入axios

// import '/static/icontfont/icontfont.css'
// eslint-disable-next-line
// require(`${process.env.BASE_URL}/icontfont/icontfont.css`)


Vue.config.productionTip = false;
Vue.prototype.$axios = axios;//把axios挂载到vue上

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
